import { motion } from "framer-motion";
import Loader from "./Loader";

export function OrderLoading() {
  return (
    <motion.div
      className="max-w-md w-full space-y-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1],
        scale: {
          type: "spring",
          damping: 15,
          stiffness: 200,
        },
      }}
    >
      <div className="w-full min-h-[60vh] flex flex-col justify-center items-center text-foreground">
        <div className="flex flex-col gap-y-8">
          <div className="text-2xl tracking-tighter font-medium">
            Processing...
          </div>

          <Loader size={32} />
        </div>
      </div>
    </motion.div>
  );
}
